"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwLoader = _interopRequireDefault(require("./CwLoader.scss"));

var CwLoader = function CwLoader(props) {
  return _react.default.createElement("div", {
    "data-name": 'CwLoader',
    className: (0, _classnames.default)(props.className, (0, _defineProperty2.default)({}, _CwLoader.default.hidden, props.loaderCnt === 0)),
    style: props.style
  }, _react.default.createElement("div", {
    className: _CwLoader.default.loaderBg
  }), _react.default.createElement("div", {
    className: _CwLoader.default.loaderBox
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_CwLoader.default.loading, _CwLoader.default.outer)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_CwLoader.default.loading, _CwLoader.default.inner)
  })), props.message.length > 0 && _react.default.createElement("div", {
    "data-name": 'CwLoader-message',
    className: _CwLoader.default.loaderText
  }, props.message)));
};

CwLoader.propTypes = {
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Loader count, if value is greater than 0, loader is shown
   */
  loaderCnt: _propTypes.default.number.isRequired,

  /**
   * Message to display under loader circle
   */
  message: _propTypes.default.string,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object
};
CwLoader.defaultProps = {
  className: '',
  message: 'Loading...',
  style: {}
};
var _default = CwLoader;
exports.default = _default;